import OBase from './OBase';
import * as Geometry from '../geometry';

export default class SimplifyTree extends OBase {
  update () {
    let inputTree = this.getObjectInput('Tree');
    let pOutput = this.outputs['Tree'].paramObject;

    let tree = Simplify(inputTree);
    pOutput.value = tree;
  }
}

function Simplify (inputTree) {
  if(inputTree.branches.length == 1) return inputTree;
  var tree = new Geometry.DataTree();

  var initialIndices = inputTree.paths[0].indices;
  var checkList = [];
  for (let i = 0; i < initialIndices.length; i++) {
    checkList.push(false);
  }

  for (let i = 0; i < inputTree.paths.length; i++) {
    var path = inputTree.paths[i];

    if (checkList.length === path.indices.length) {
      for (let t = 0; t < path.indices.length; t++) {
        let indice = path.indices[t];
        let initialIndice = initialIndices[t];

        if (indice !== initialIndice) {
          checkList[t] = true;
        }
      }
    }
  }

  var dupIndexes = [];
  for (let i = 0; i < checkList.length; i++) {
    if (checkList[i] === false) {
      dupIndexes.push(i);
    }
  }

  for (let i = 0; i < inputTree.branches.length; i++) {
    var newIndices = [...inputTree.paths[i].indices];
    
    for (let t = dupIndexes.length - 1; t >= 0; t--) {
      newIndices.splice(dupIndexes[t], 1);
    }

    var newPath = new Geometry.GHPath(newIndices);
    tree.addEmpty(newPath);
    for (let j = 0; j < inputTree.branches[i].length; j++) {
      var inputObj = inputTree.branches[i][j];
      tree.add(inputObj, newPath);
    }
  }

  return tree;
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/SimplifyTree.js